(() => {
  const initCollection = (root) => {
    if (!root || root.dataset.wiCollectionReady === 'true') return;
    root.dataset.wiCollectionReady = 'true';

    const form = root.querySelector('[data-wi-collection-form]');
    const sort = root.querySelector('[data-wi-collection-sort]');
    const filters = Array.from(root.querySelectorAll('[data-wi-collection-filter]'));

    if (form && sort) {
      sort.addEventListener('change', () => {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    }

    filters.forEach((filter) => {
      filter.addEventListener('toggle', () => {
        if (!filter.open) return;

        filters.forEach((otherFilter) => {
          if (otherFilter !== filter) otherFilter.open = false;
        });
      });
    });

    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-wi-collection-filter]')) return;

      filters.forEach((filter) => {
        filter.open = false;
      });
    });

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      filters.forEach((filter) => {
        filter.open = false;
      });
    });
  };

  const initAllCollections = (scope = document) => {
    scope.querySelectorAll('[data-wi-collection]').forEach(initCollection);
  };

  initAllCollections();

  document.addEventListener('shopify:section:load', (event) => {
    initAllCollections(event.target);
  });
})();
